import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/auth/login' },
  { 
    path: 'auth', 
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  { 
    path: 'app', 
    loadChildren: () => import('./layouts/authenticated-layout/authenticated-layout.routes').then(m => m.AUTHENTICATED_LAYOUT_ROUTES)
  },
  { path: 'login', redirectTo: '/auth/login' },
  { path: 'dashboard', redirectTo: '/app/dashboard' },
  { path: 'applications', redirectTo: '/app/applications' },
  { path: 'templates', redirectTo: '/app/templates' },
  { path: 'references', redirectTo: '/app/references' },
  { path: 'event-availability', redirectTo: '/app/event-availability' },
  { path: '**', redirectTo: '/auth/login' }
];

